module.exports = __webpack_public_path__ + "img/event_ico.04ad2e96.png";